import React from 'react';
import { BinocularsIcon } from 'lucide-react';
import type { Widget } from '@airhead-games/shared/content';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface WidgetEmptyStateProps {
  widget: Extract<Widget, { type: 'emptyState' }>;
}

const WidgetEmptyState: React.FC<WidgetEmptyStateProps> = ({ widget }) => (
  <Empty className={`border ${widget.minHeightClassName ?? 'min-h-[18rem]'}`}>
    <EmptyHeader>
      {widget.icon === 'binoculars' && (
        <EmptyMedia variant="icon">
          <BinocularsIcon aria-hidden="true" />
        </EmptyMedia>
      )}
      <EmptyTitle>{widget.title}</EmptyTitle>
      {widget.description && (
        <EmptyDescription>{widget.description}</EmptyDescription>
      )}
    </EmptyHeader>
  </Empty>
);

export default WidgetEmptyState;
